module.exports = __webpack_public_path__ + "img/zhengjiajidihaiyangshijie.7f6be53b.png";